document.addEventListener("DOMContentLoaded",function() {
    const body             = document.body;
    const modeToggle    = document.querySelector(".toggle");
    let currentMode = localStorage.getItem('mode');

    function setMode(mode) {
        if(mode === 'dark') {
			// SET DARK MODE
            body.classList.remove('light-mode');
            body.classList.add('dark-mode');
            modeToggle.classList.remove("toggle--light-mode");
            modeToggle.classList.add("toggle--dark-mode");
            localStorage.setItem('mode', 'dark');
        } else {
			// SET LIGHT MODE
            body.classList.remove('dark-mode');
            body.classList.add('light-mode');
            modeToggle.classList.remove("toggle--dark-mode");
            modeToggle.classList.add("toggle--light-mode");
            localStorage.setItem('mode', 'light');
        }
    }

    // On initial load assign dark mode (default)
    if(!localStorage.hasOwnProperty('mode')) {
        setMode('dark');
    }

    // Blanket check on page load and ensure relevant body class is added
    if(currentMode === 'dark') {
        setMode('dark');
    } else if(currentMode === 'light') {
        setMode('light');
    } else {
        setMode('dark');
    }

    // Assign on toggle
    modeToggle.addEventListener("click", function () {
        let currentMode = localStorage.getItem('mode');
        if(currentMode === 'dark') {
            setMode('light');
			this.navTracking = document.querySelectorAll("body.light-mode [data-nav-watch]");
			this.navTracking.forEach((section) => {
				window.app.observer.observer2.observe(section);
			});
        } else {
            setMode('dark');
        }
    })

});